import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      // iter478 — Brand-tinted background + visible inactive state. The
      // default muted-on-white made inactive tabs invisible on dashboard.
      "inline-flex h-10 items-center justify-center rounded-xl p-1 text-slate-600",
      "bg-gradient-to-r from-violet-100/80 via-pink-100/70 to-purple-100/80",
      "border border-violet-200/70 shadow-sm",
      "dark:from-slate-800/80 dark:via-slate-800/60 dark:to-slate-800/80 dark:border-white/10 dark:text-slate-300",
      className
    )}
    {...props} />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-lg px-3.5 py-1.5 text-sm font-semibold transition-all",
      "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pink-400 focus-visible:ring-offset-2",
      "disabled:pointer-events-none disabled:opacity-50",
      // Inactive: subtle, but with hover lift toward brand pink/violet
      "text-slate-700 hover:text-violet-700 hover:bg-white/70 dark:text-slate-300 dark:hover:text-white dark:hover:bg-white/10",
      // Active: brand gradient + ring for contrast
      "data-[state=active]:bg-gradient-to-r data-[state=active]:from-pink-500 data-[state=active]:via-fuchsia-500 data-[state=active]:to-violet-600",
      "data-[state=active]:text-white data-[state=active]:shadow-md data-[state=active]:shadow-violet-500/40",
      "data-[state=active]:ring-1 data-[state=active]:ring-white/30 dark:data-[state=active]:ring-white/20",
      className
    )}
    {...props} />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className
    )}
    {...props} />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
